import React, { useContext, useEffect, useState, useCallback } from "react";
import {Form, Input, Button, Row, Col, Modal, notification, Select,
  InputNumber, List, Popconfirm, Upload} from "antd";
import axios from "axios";
import GlobalContext from "../../utils/GlobalContext";
import mergeProps from "../../utils/MergeProps";
import { DeleteOutlined, UploadOutlined} from "@ant-design/icons";
import { POINT_TYPES } from "../../utils/Constants";
import LoadingModal from "../../utils/LoadingModal";

const { Option } = Select;
const { TextArea } = Input;

const MeetingNewPointsForm = ({
  open,
  isEdit,
  currentMeetingNewPoint,
  onFinish,
  onCancel,
  currentMeeting,
  currentParentPoint=null
}) => {
  const globals = useContext(GlobalContext);
  const [form] = Form.useForm();
  const [point_types, setPointTypes] = useState([]);
  const [classifications, setClassifications] = useState([]);
  const [fileList, setFileList] = useState([]);
  const [uploadFileList, setUploadFileList] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchPointTypes = useCallback(async () => {
    try {
      await new Promise((resolve) => setTimeout(resolve, 100));
      const response = await axios.get(
        `${globals.SERVICE_API_DB}/v1/point-types`,
        {
          headers: {
            "x-token": globals.token,
          },
        }
      );
      if (!isEdit) {
        response.data.data = response.data.data.filter((pointType) => pointType.name === "Nuevo");
      }
      // if (isEdit) response.data.data = response.data.data.filter((pointType) => pointType.name === "Nuevo"  || pointType.name === "Estándar");
      // else response.data.data = response.data.data.filter((pointType) => pointType.name === "Nuevo");
      setPointTypes(response?.data?.data);
    } catch (error) {
      console.error("Error fetching point types:", error.response);
      notification.error({
        message: "Error obteniendo tipos de puntos de plantilla",
        placement: "bottomRight",
      });
    }
    // setLoadingClients(false);
  }, [globals.SERVICE_API_DB, globals.token, isEdit]);

  const fetchClassifications = useCallback(async () => {
    try {
      // setLoadingClients(true);
      await new Promise((resolve) => setTimeout(resolve, 100));
      const response = await axios.get(
        `${globals.SERVICE_API_DB}/v1/classifications`,
        {
          headers: {
            "x-token": globals.token,
          },
        }
      );
      setClassifications(response?.data?.data);
    } catch (error) {
      console.error("Error fetching classifications:", error.response);
      notification.error({
        message: "Error obteniendo clasificaciones",
        placement: "bottomRight",
      });
    }
    // setLoadingClients(false);
  }, [globals.SERVICE_API_DB, globals.token]);

  const fetchAttachments = useCallback(async () => {
    try {
      const response = await axios.get(
        `${globals.SERVICE_API_DB}/v1/consult-attach-files/${currentMeetingNewPoint.id}`,
        {
          headers: {
            "x-token": globals.token,
          },
        }
      );
      console.log("response", response.data.data);
      setFileList(response?.data?.data.rows);
    } catch (error) {
      console.error("Error fetching attachments:", error.response);
      if (error?.response?.data.status !== -2) {
        notification.error({
          message: "Error obteniendo archivos adjuntos",
          placement: "bottomRight",
        });
      }
    }
  }, [globals, currentMeetingNewPoint]);

  useEffect(() => {
    if (isEdit) {
      fetchAttachments();
      const pointType = point_types.find((pointType) => pointType.name === currentMeetingNewPoint.point_type_name);
      const classification = classifications.find((classification) => classification.name === currentMeetingNewPoint.classification_name);
      form.setFieldsValue({
        name: currentMeetingNewPoint.name,
        description: currentMeetingNewPoint.description,
        point_type_name: pointType?.name,
        classification_name: classification?.name,
        classificationId: currentMeetingNewPoint.classificationId,
        duration: currentMeetingNewPoint.duration,
        responsible: currentMeetingNewPoint.responsible,
      });
    }
    else{
      form.setFieldsValue({
        duration: 15,
      });
    }
  }, [isEdit, currentMeetingNewPoint, form, open, point_types, classifications, fetchAttachments]);

  useEffect(() => {
    fetchPointTypes();
    fetchClassifications();
  }, [
    fetchClassifications,
    fetchPointTypes,
  ]);

  const handleAddFile = async ({ file, onSuccess, onError }) => {
    const formData = new FormData();
    formData.append('files', file);
    formData.append('meetingPointDetailsId', currentMeetingNewPoint.id);

    setLoading(true);
    try {
      const response = await axios.post(`${globals.SERVICE_API_DB}/v1/create-attach-file`, formData, {
        headers: {
          "x-token": globals.token,
          "Content-Type": "multipart/form-data",
        },
      });

      onSuccess(response, file);
      console.log("response", response.data);
      setFileList([...fileList, response.data.data[0]]);
      notification.success({
        message: `${file.name} cargado correctamente.`,
        placement: "bottomRight",
      });
    } catch (error) {
      onError(error);
      notification.error({
        message: `Error al cargar ${file.name}.`,
        placement: "bottomRight",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleFileDelete = async (file) => {

    try {
      const response = await axios.delete(`${globals.SERVICE_API_DB}/v1/delete-attach-file/${file.id}`, {
        headers: {
          "x-token": globals.token,
        },
      });
      console.log("response", response);  
      if (response.data.status === 0) {
        notification.success({
          message: `${file.name} eliminado correctamente.`,
          placement: "bottomRight",
        });
        
        setFileList(fileList.filter((f) => f.id !== file.id));
      }
      else{
        notification.error({
          message: `Error al eliminar ${file.name}.`,
          placement: "bottomRight",
        });
      }
    }
    catch (error) {
      console.error("Error deleting file:", error.response);
      notification.error({
        message: "Error eliminando archivo",
        placement: "bottomRight",
      });
    }
    
    
  };

  const handleComplete = async (values) => {
    try {
      values.meeting_type_name = currentMeeting.meeting_type_name;
      values.department_name = currentMeeting.department_name;
      values.pointTypesId = POINT_TYPES.NUEVO;
      values.statusMeetingPointDetailId = 1;
      if (currentParentPoint) {
        values.parentId = currentParentPoint.id;
      }
      if (isEdit) {
        values.pointTypesId = currentMeetingNewPoint.pointTypesId;
        values.statusMeetingPointDetailId = currentMeetingNewPoint.statusMeetingPointDetailId;
        values.id = currentMeetingNewPoint.id;
        
        const response = await axios.put(
          `${globals.SERVICE_API_DB}/v1/update-meeting-point-detail/${currentMeetingNewPoint.id}`,
          values,
          {
            headers: {
              "x-token": globals.token,
            },
          }
        );
        if (response?.data?.status === 0) {
          const childPoints = currentMeetingNewPoint.childPoints;
          currentMeetingNewPoint = mergeProps(currentMeetingNewPoint, response?.data?.data);
          currentMeetingNewPoint.childPoints = childPoints;
          onFinish({ status: "edited" });
        }
        setFileList([]);
        setUploadFileList([]);
        form.resetFields();
        return;
      }
      const response = await axios.post(
        `${globals.SERVICE_API_DB}/v1/create-meeting-point-details/${currentMeeting.id}`,
        values,
        {
          headers: {
            "x-token": globals.token,
          },
        }
      );
      
      setFileList([]);
      setUploadFileList([]);
      form.resetFields();
      onFinish({ status: "created", newMeetingPoint: response?.data?.data});
    } catch (error) {
      console.error("Error submitting form:", error);
      notification.error({
        message: "Error guardando punto de reunión",
        placement: "bottomRight",
      });
    }
  };

  const handleCancel = () => {
    setFileList([]);
    setUploadFileList([]);
    form.resetFields();
    onCancel();
  };

  return (
    <Modal
      title={isEdit ? "Editar Punto de reunión nuevo" : "Crear Punto de reunión"}
      open={open}
      onOk={handleCancel}
      onCancel={handleCancel}
      footer={null}
    >
      <LoadingModal open={loading} />
      <Form form={form} layout="vertical" onFinish={handleComplete}>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="point_type_name"
              label="Tipo de punto"
              rules={[{ required: true, message: "Selecciona una opción" }]}
            >
              <Select 
                placeholder="Selecciona una opción"
                disabled={isEdit}
              >
                {point_types.map((option) => (
                  <Option key={option.id} value={option.name}>
                    {option.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="classificationId"
              label="Clasificación"
              rules={[{ required: true, message: "Selecciona una opción" }]}
            >
              <Select placeholder="Selecciona una opción">
                {classifications.map((option) => (
                  <Option key={option.id} value={option.id}>
                    {option.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Form.Item
          name="name"
          label="Nombre del punto"
          rules={[
            { required: true, message: "Este campo es requerido" },
            { max: 80, message: "Máximo 80 caracteres" },]}
        >
          <Input 
            maxLength={80}
            showCount
          />
        </Form.Item>
        <Row gutter={16}>
          <Col span={5}>
              <Form.Item label="Duración" name="duration" tooltip="minutos">
                <InputNumber
                  min={1}
                />
              </Form.Item>
          </Col>
          <Col span={19}>
            <Form.Item
            name="responsible"
            label="Responsable"
            tooltip="Debe ingresar el correo electrónico del responsable"
            rules={[
              { type: 'email', message: "Ingrese un email válido" },
              { required: true, message: "Por favor ingrese un email" },
            ]}
          >
            <Input
              placeholder="Ingrese un correo electrónico"
            />
          </Form.Item>
        </Col>
        </Row>
        {isEdit && (
          <>
          <Form.Item 
            label="Descripción" 
            name="description"
            rules={[
              { max: 200, message: "Máximo 200 caracteres" }]}
          >
            <TextArea 
              rows={4}
              maxLength={200}
              showCount
              />
          </Form.Item>
        <Row gutter={16}>
          <Col span={12}>
            <Upload
              showUploadList={false}
              customRequest={handleAddFile}
              fileList={uploadFileList}
              onChange={(info) => {
                setUploadFileList(info.fileList);
              }}
            >
              <Button icon={<UploadOutlined />}>Cargar adjuntos</Button>
            </Upload>
          </Col>
        </Row>
        <Form.Item label="Archivos adjuntos">
          <List
            dataSource={fileList}
            renderItem={file => (
              <List.Item
                actions={[
                  <Popconfirm
                    title="¿Está seguro que desea eliminar este archivo?"
                    onConfirm={() => handleFileDelete(file)}
                    okText="Sí"
                    cancelText="No"
                  >
                    <Button icon={<DeleteOutlined />} danger>Eliminar</Button>
                  </Popconfirm>
                ]}
              >
                <List.Item.Meta
                  title={<a href={file.url} target="_blank" rel="noopener noreferrer">
                  {file.name}
                </a>}
                />
              </List.Item>
            )}
          />
        </Form.Item>
        </>
        )}
        <Row justify="end">
          <Col>
            <Button style={{ marginRight: 8 }} type="primary" htmlType="submit">
              {isEdit ? "Actualizar" : "Crear"}
            </Button>
            <Button style={{ marginRight: 8 }} onClick={handleCancel}>
              Cancelar
            </Button>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default MeetingNewPointsForm;
